import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Wrap = styled.button`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    text-align: left;
`;

export const Swatch = styled.span<{ $color: string | null }>`
    width: 44px;
    height: 44px;
    flex: 0 0 auto;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${({ $color }) => $color || colors.surface};
`;

export const LabelText = styled.span`
    font-size: 0.9375rem;
    color: ${colors.textPrimary};
`;

export const ValueText = styled.span`
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;
